import { VStack } from '@chakra-ui/react';
import { FC } from 'react';

import { useLecturePageQueryParams } from '@/components/ui/features/lecture/hooks';
import { CommentInput } from '@/components/ui/features/lecture/LectureDiscussion/components/CommentInput';
import { CommentList } from '@/components/ui/features/lecture/LectureDiscussion/components/CommentList';
import { ErrorFallback } from '@/components/ui/shared/overlays/ErrorFallback/ErrorFallback';
import { BugsnagErrorBoundary } from '@/components/ui/shared/utilities/BugsnagErrorBoundary/BugsnagErrorBoundary';

export const LectureDiscussion: FC = () => {
  const { id: lectureId } = useLecturePageQueryParams();

  return (
    <VStack spacing={8} align="stretch">
      <CommentInput lectureId={lectureId} />
      <BugsnagErrorBoundary FallbackComponent={ErrorFallback}>
        <CommentList lectureId={lectureId} />
      </BugsnagErrorBoundary>
    </VStack>
  );
};
